"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkPolicy = checkPolicy;
/**
 * Check a policy result.  Returns true if policy result exists and has no failure reason, false other
 * @param policyResult
 */
function checkPolicy(policyResult) {
    return !!(policyResult && policyResult.failureReason == null);
}
//# sourceMappingURL=PolicyResultHelper.js.map